/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiScreeningClearanceRuleContent,
    InternalApiScreeningClearanceRuleContentFromJSON,
    InternalApiScreeningClearanceRuleContentToJSON,
} from '../models';

export interface AddRuleContentRequest {
    handle: string;
    internalApiScreeningClearanceRuleContent: InternalApiScreeningClearanceRuleContent;
}

export interface DeleteRuleContentRequest {
    handle: string;
    id: number;
}

export interface UpdateRuleContentRequest {
    handle: string;
    id: number;
    internalApiScreeningClearanceRuleContent: InternalApiScreeningClearanceRuleContent;
}

/**
 * 
 */
export class ScreeningClearanceRuleContentApi extends runtime.BaseAPI {

    /**
     * Creates new rule content
     */
    async addRuleContentRaw(requestParameters: AddRuleContentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRuleContent>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling addRuleContent.');
        }

        if (requestParameters.internalApiScreeningClearanceRuleContent === null || requestParameters.internalApiScreeningClearanceRuleContent === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRuleContent','Required parameter requestParameters.internalApiScreeningClearanceRuleContent was null or undefined when calling addRuleContent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRuleContentToJSON(requestParameters.internalApiScreeningClearanceRuleContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRuleContentFromJSON(jsonValue));
    }

    /**
     * Creates new rule content
     */
    async addRuleContent(requestParameters: AddRuleContentRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRuleContent> {
        const response = await this.addRuleContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete rule content
     */
    async deleteRuleContentRaw(requestParameters: DeleteRuleContentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling deleteRuleContent.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteRuleContent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}/content/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete rule content
     */
    async deleteRuleContent(requestParameters: DeleteRuleContentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteRuleContentRaw(requestParameters, initOverrides);
    }

    /**
     * Updates rule content
     */
    async updateRuleContentRaw(requestParameters: UpdateRuleContentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiScreeningClearanceRuleContent>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling updateRuleContent.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRuleContent.');
        }

        if (requestParameters.internalApiScreeningClearanceRuleContent === null || requestParameters.internalApiScreeningClearanceRuleContent === undefined) {
            throw new runtime.RequiredError('internalApiScreeningClearanceRuleContent','Required parameter requestParameters.internalApiScreeningClearanceRuleContent was null or undefined when calling updateRuleContent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/screening-clearance-rules/{handle}/content/{id}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiScreeningClearanceRuleContentToJSON(requestParameters.internalApiScreeningClearanceRuleContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiScreeningClearanceRuleContentFromJSON(jsonValue));
    }

    /**
     * Updates rule content
     */
    async updateRuleContent(requestParameters: UpdateRuleContentRequest, initOverrides?: RequestInit): Promise<InternalApiScreeningClearanceRuleContent> {
        const response = await this.updateRuleContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
